import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type ToastState = {
  message: string | null;
  type: "success" | "error" | "info";
};

const initialState: ToastState = {
  message: null,
  type: "success",
};

export const toastSlice = createSlice({
  name: "toast",
  initialState,
  reducers: {
    showToast: (state, action: PayloadAction<{ message: string; type?: "success" | "error" | "info" }>) => {
      state.message = action.payload.message;
      state.type = action.payload.type ?? "success";
    },
    hideToast: (state) => {
      state.message = null;
    },
  },
});

export const { showToast, hideToast } = toastSlice.actions;
export default toastSlice.reducer;
